import { render, staticRenderFns } from "./CorrespondenceManage.vue?vue&type=template&id=5a925cd2&"
import script from "./CorrespondenceManage.vue?vue&type=script&lang=js&"
export * from "./CorrespondenceManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports